<script setup lang="ts">
import EnvironmentIndicator from '@plf/components/layout/environment/EnvironmentIndicator.vue'
import NotificationsContainer from '@plf/components/layout/shared/NotificationsContainer.vue'
import LogoFull from '~icons/cue/logo_full'

useHead({
  htmlAttrs: {
    class: 'auth',
  },
})
</script>

<template lang="pug">
.auth-layout.flex-center-center.w-100p.position-relative
  .position-fixed.t-0.l-32.z-index-20
    EnvironmentIndicator
  UiIcon.logo.flex-shrink-0(:name="LogoFull")
  .window.br-20.max-w-400.w-100p.m-8.m-t-124.m-b-100.z-index-10
    slot
  .caption.typ-14-18-500.max-w-210.text-center {{ $t('layout.online_booking') }}
  NotificationsContainer.position-fixed.z-index-1000
  .position-fixed.z-index-500#bottom-sheet
</template>

<style scoped>
.auth-layout {
  min-width: 100vw;
  @supports (min-width: 100dvw) {
    min-width: 100dvw;
  }

  min-height: 100vh;
  @supports (min-height: 100dvh) {
    min-height: 100dvh;
  }

  background: var(--cue-bg-primary-default);
}

.logo {
  position: fixed;
  --uno: t-16 l-8 w-118 h-32;
  color: var(--cue-static-neutral-main) !important;

  @screen sm {
    --uno: t-32 l-32 w-118 h-32;
  }
}

.window {
  background: var(--cue-bg-surface-highest);
}

.caption {
  position: absolute;
  bottom: 40px;
  color: var(--cue-static-primary-soft);
}
</style>

<style>
html.auth {
  background: var(--cue-bg-primary-default);
}
</style>
